export default "__VITE_PUBLIC_ASSET__ff9fb8fb__"